<template>
  <v-dialog
    v-model="internal"
    persistent
    width="500"
  >
    <v-card>
      <!-- HEADER -->
      <v-card-actions class="d-flex justify-space-between">
        <v-card-title>
          {{$t('broker.labels.selectClientOperation')}}
        </v-card-title>

        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>

      <!-- BODY -->
      <v-card-text class="py-0">
        <div class="d-flex flex-gap-2 flex-column my-2 mx-3 py-0">
          <v-card-subtitle class="my-2">{{$t('broker.labels.transactionPurpose')}}</v-card-subtitle>
          <v-select
              v-model="operationType"
              data-testid="operation-type"
              :items="list"
              item-text="text"
              item-value="value"
              outlined
              dense
            />
        </div>
      </v-card-text>

      <!-- FOOTER -->
      <v-card-actions class="d-flex justify-end">
        <v-btn
          color="primary"
          class="ma-2"
          data-testid="operation-type-next"
          @click="nextStep"
          :disabled="!operationType"
        >
          Next
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SelectOperationTypeDialog",
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      operationType: null,
    }
  },
  computed: {
    internal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      }
    },
    list(){
      const operationTypes = this.$t('broker.operationTypes')
      return Object.entries(operationTypes).map(([key,label])=> ({text: label, value : key}))
    }
  },
  methods: {
    closeDialog() {
      this.$emit("input", false)
      this.operationType = null
    },

    nextStep() {
      const payload = {
        remessa: this.operationType,
      }
      this.$emit("input", false)
      this.$emit('operation-details-submitted', payload)
      this.operationType = null
    }
  }
}
</script>
